<script setup>
import {ref, watch} from 'vue';
import OrderBadgeForm from '@/components/resources/order-badges/components/OrderBadgeForm.vue';
import {useI18n} from "vue-i18n";

const {t} = useI18n();

const props = defineProps({
  isOpen: {
    type: Boolean,
    default: false
  },
  badge: {
    type: Object,
    default: null
  }
});

const emit = defineEmits(['close', 'submit']);

const formData = ref({});
const isEdit = ref(false);

watch(() => props.badge, (newBadge) => {
  if (newBadge) {
    formData.value = {...newBadge};
    isEdit.value = true;
  } else {
    formData.value = {};
    isEdit.value = false;
  }
}, {immediate: true});

const handleSubmit = (data) => {
  emit('submit', {data, isEdit: isEdit.value});
};

const close = () => {
  emit('close');
};
</script>

<template>
  <div v-if="isOpen" class="modal fade show d-block" tabindex="-1" @click.self="close">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">
            {{ t(isEdit ? 'common.crud.titles.edit' : 'common.crud.titles.create', {name: t('labels.badge')}) }}
          </h5>
          <button type="button" class="btn-close" @click="close"></button>
        </div>
        <div class="modal-body">
          <OrderBadgeForm
              :initial-data="formData"
              @submit="handleSubmit"
              @cancel="close"
          />
        </div>
      </div>
    </div>
  </div>
  <div v-if="isOpen" class="modal-backdrop fade show"></div>
</template>

<style scoped>

</style>